export type MediaGalleryConfig = {
  translations: {
    /** Close a11y text on the modal, like: 'Close' */
    closeLabel: string;
    /** A11y text for the prev/next buttonsm like: 'Previous' */
    prevLabel: string;
    /** A11y text for the prev/next buttons, like: 'Next' */
    nextLabel: string;
    /** A11y text for carousel images, like: 'Image' */
    imageLabel: string;
    noVideoSupportLabel: string;
    playPauseButtonLabel: string;
  };
  /** A11y option to reduce motion on gallery components (browser setting) */
  hasReducedMotion: boolean;
  /** Default: false. Explicitly disable thumbnail images below the carousel only (not fullscreen) */
  disabledCarouselThumbnails?: boolean;
  /** If enabled, pressing prev/next chevron will will loop around to the last/first item on the fullscreen gallery (unless there is only 1 image) */
  wrapAroundOnModalView?: boolean;
  /** Auto=lazy */
  lazyLoading?: {
    carousel: LazyLoading;
    thumb: LazyLoading;
  };
  /** If set to true, videos will play looped */
  loopVideos?: boolean;
};

export type LazyLoading = 'auto' | 'disabled';

export const translations: MediaGalleryConfig['translations'] = {
  closeLabel: 'Close',
  prevLabel: 'Previous',
  nextLabel: 'Next',
  imageLabel: 'Image',
  noVideoSupportLabel: 'Your browser does not support the video tag.',
  playPauseButtonLabel: 'Play/pause'
};

export const mediaGalleryDefaultConfig: MediaGalleryConfig = {
  translations,
  wrapAroundOnModalView: false,
  lazyLoading: {
    carousel: 'auto',
    thumb: 'auto'
  },
  loopVideos: true,
  hasReducedMotion: false
};
